var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalRetrieve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.25C8.95431 0.25 0 9.20431 0 20.25C0 31.2957 8.95431 40.25 20 40.25C31.0457 40.25 40 31.2957 40 20.25C40 9.20431 31.0457 0.25 20 0.25Z",
    fill: "#4669BD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_99_5707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5118 25.5899C22.2084 25.8934 22.2084 26.3854 22.5118 26.6889C22.8153 26.9924 23.3073 26.9924 23.6108 26.6889L29.1057 21.194C29.4092 20.8905 29.4092 20.3985 29.1057 20.095L23.6108 14.6001C23.3073 14.2967 22.8153 14.2967 22.5118 14.6001C22.2084 14.9036 22.2084 15.3956 22.5118 15.6991L26.6771 19.8644L11.4437 19.8644C11.0146 19.8644 10.6666 20.2123 10.6666 20.6415C10.6666 21.0706 11.0146 21.4186 11.4437 21.4186L26.6832 21.4186L22.5118 25.5899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5118 25.5899C22.2084 25.8934 22.2084 26.3854 22.5118 26.6889C22.8153 26.9924 23.3073 26.9924 23.6108 26.6889L29.1057 21.194C29.4092 20.8905 29.4092 20.3985 29.1057 20.095L23.6108 14.6001C23.3073 14.2967 22.8153 14.2967 22.5118 14.6001C22.2084 14.9036 22.2084 15.3956 22.5118 15.6991L26.6771 19.8644L11.4437 19.8644C11.0146 19.8644 10.6666 20.2123 10.6666 20.6415C10.6666 21.0706 11.0146 21.4186 11.4437 21.4186L26.6832 21.4186L22.5118 25.5899Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.25C31.0457 0.25 40 9.20431 40 20.25C40 31.2957 31.0457 40.25 20 40.25V0.25Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_99_5707",
    x: 10.1666,
    y: 13.8726,
    width: 21.6667,
    height: 14.5439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_5707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_99_5707",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalRetrieve);
export default __webpack_public_path__ + "static/media/approval_retrieve.db663029520ef4bdf35e213591dac9ca.svg";
export { ForwardRef as ReactComponent };